// Função para exportar Invoice para Excel
// Nota: Para usar esta funcionalidade, instale a biblioteca: npm install xlsx
// import * as XLSX from 'xlsx';

export const exportInvoiceToExcel = (invoice, boxes) => {
  // Por enquanto, vamos criar um CSV que pode ser aberto no Excel
  // Para uma implementação completa com formatação, use a biblioteca xlsx

  const invoiceData = [];

  // Cabeçalho
  invoiceData.push([`INVOICE - ${invoice.numero}`]);
  invoiceData.push([]);
  invoiceData.push(['Cliente:', invoice.cliente]);
  invoiceData.push(['Data:', new Date(invoice.data).toLocaleDateString('pt-BR')]);
  invoiceData.push(['Status:', invoice.status]);
  invoiceData.push([]);

  // Caixas/Malas
  invoiceData.push(['CAIXAS / MALAS']);
  invoiceData.push(['Código', 'Cliente', 'Valor Declarado']);

  invoice.caixas_malas.forEach(boxId => {
    const box = boxes.find(b => b.id === boxId);
    if (box) {
      invoiceData.push([box.codigo, box.cliente_nome, box.valor_declarado]);
    }
  });

  invoiceData.push([]);

  // Totais
  const invoiceTotal = invoice.caixas_malas.reduce((sum, boxId) => {
    const box = boxes.find(b => b.id === boxId);
    if (box) {
      const value = parseFloat(box.valor_declarado.replace('R$', '').replace(',', '.').trim()) || 0;
      return sum + value;
    }
    return sum;
  }, 0);

  invoiceData.push(['TOTAL INVOICE', invoiceTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })]);

  // Converter para CSV
  const csvContent = invoiceData.map(row =>
    row.map(cell => {
      if (cell === null || cell === undefined) return '';
      return String(cell).replace(/"/g, '""');
    }).join(',')
  ).join('\n');

  // Criar e baixar arquivo
  const blob = new Blob([`\ufeff${csvContent}`], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);

  link.setAttribute('href', url);
  link.setAttribute('download', `Invoice_${invoice.numero}_${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Para uma implementação completa com formatação Excel (.xlsx), descomente e use:
  /*
  import * as XLSX from 'xlsx';

  const ws = XLSX.utils.aoa_to_sheet(invoiceData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Invoice');
  XLSX.writeFile(wb, `Invoice_${invoice.numero}_${new Date().toISOString().split('T')[0]}.xlsx`);
  */
};
